import SlideApi from '@/api/slide'
import AudienceApi from '@/api/audience'

const initResources = () => {
  SlideApi.initResource()
  AudienceApi.initResource()
}

export default {
  initResources,
}
